define(["require", "exports", "knockout", "./CPPackageModuleModel"], function (require, exports, ko, CpPackageModuleModel) {
    "use strict";
    var CPPackageModel = /** @class */ (function () {
        function CPPackageModel(data) {
            this.Id = ko.observable(0);
            this.Name = ko.observable();
            this.Description = ko.observable();
            this.Modules = ko.observableArray();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CPPackageModel.Mapping, self);
            }
        }
        Object.defineProperty(CPPackageModel.prototype, "SelectedModuleGroups", {
            get: function () {
                var self = this;
                var groupsObj = {};
                for (var _i = 0, _a = (self.Modules() || []); _i < _a.length; _i++) {
                    var module = _a[_i];
                    if (module.Selected()) {
                        groupsObj[module.Group()] = module.Group();
                    }
                }
                var moduleGroups = Object.getOwnPropertyNames(groupsObj);
                return moduleGroups;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(CPPackageModel.prototype, "ModuleGroups", {
            get: function () {
                var self = this;
                var groupsObj = {};
                for (var _i = 0, _a = (self.Modules() || []); _i < _a.length; _i++) {
                    var module = _a[_i];
                    groupsObj[module.Group()] = module.Group();
                }
                var moduleGroups = Object.getOwnPropertyNames(groupsObj);
                return moduleGroups;
            },
            enumerable: false,
            configurable: true
        });
        CPPackageModel.prototype.GetGroupModules = function (group, onlySelected) {
            var self = this;
            if (onlySelected) {
                return (self.Modules() || []).filter(function (x) { return x.Group() == group && x.Selected(); });
            }
            return (self.Modules() || []).filter(function (x) { return x.Group() == group; });
        };
        CPPackageModel.prototype.toggleSelection = function (group, select) {
            var self = this;
            for (var _i = 0, _a = (self.Modules() || []); _i < _a.length; _i++) {
                var module = _a[_i];
                if (module.Group() == group) {
                    module.Selected(select);
                }
            }
        };
        CPPackageModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CPPackageModel(options.data);
            },
            Modules: {
                create: function (options) {
                    return new CpPackageModuleModel(options.data);
                }
            }
        };
        return CPPackageModel;
    }());
    return CPPackageModel;
});
//# sourceMappingURL=CPPackageModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CPPackageModel.js
// module id = 45
// module chunks = 2